module.exports = __webpack_public_path__ + "static/media/DetectText.fe9c14ab.svg";